<template>
  <div class="record-item">
    <var-row>
      <van-col span="6" style="border: 1px solid #fff;padding: 4px 0;height: 38px;line-height: 38px;">{{ SafeItem.id }}</van-col>
      <van-col span="6" style="border: 1px solid #fff;padding: 4px 0;height: 38px;line-height: 38px;">{{ SafeItem.nickname }}</van-col>
      <van-col span="6" style="border: 1px solid #fff;padding: 4px 0;height: 38px;line-height: 38px;">{{ SafeItem.today_coded_vol }}</van-col>
      <van-col span="6" style="border: 1px solid #fff;padding: 4px 0;height: 38px;line-height: 38px;"
        ><a
          style="
            text-align: center;
            color: #cbb788;
          "
          @click="parentToshow(0)"
        >
          授权代理
    </a></van-col
      >
    </var-row>
  </div>
</template>

<script>
export default {
  name: 'UsrInfView2',
  props: ['item'],
  computed: {
    SafeItem () {
      return this.item || null
    }
  },
  data () {
    return {}
  },
  methods: {
    parentToshow (type) {
      this.$emit('change-zhekou', this.SafeItem,type)
    }
  }
}
</script>

<style lang="scss" scoped>
.record-item {
  width: 96%;
  margin: 0px auto;
  padding: 10px 0px;
  text-align: center;
}
</style>
